// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/sources/DefaultLogSizeSelectorWarningModal.scss
// module id = 1321
// module chunks = 0